module.exports = __webpack_public_path__ + "static/media/12.36c23ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/12.png
// module id = 514
// module chunks = 0